const ALWAYS_USE_CASH_STORAGE_KEY = "checkout-always-use-cash";
// 로컬 스토리지에서 항상 전액 사용 설정 불러오기
const getAlwaysUseCashValue = ()=>{
    if ("object" === "undefined") return false;
    const stored = localStorage.getItem(ALWAYS_USE_CASH_STORAGE_KEY);
    return stored === "true";
};
// 로컬 스토리지에 항상 전액 사용 설정 저장
const setAlwaysUseCashValue = (value)=>{
    if ("object" === "undefined") return;
    localStorage.setItem(ALWAYS_USE_CASH_STORAGE_KEY, String(value));
};
const alwaysUseCashApi = {
    getValue: getAlwaysUseCashValue,
    setValue: setAlwaysUseCashValue
};
/**
 * 항상 전액 사용 설정을 로컬 스토리지에서 관리하는 훅
 * 로컬 스토리지 읽기/쓰기 기능만 제공합니다.
 */ const useAlwaysUseCash = ()=>{
    return alwaysUseCashApi;
};
export default useAlwaysUseCash;
